// Turns the "message" part of an API response into text for an alert.
// The Laravel API sends errors in three shapes: a plain string, { error: "..." },
// or validator output { field: ["...", ...], ... }. Anything else falls back.
export function formatServerMessage(message, fallback) {
	if (message == null) {
		return fallback;
	}
	if (typeof message === 'string') {
		return message;
	}
	if (Array.isArray(message)) {
		return message.join('\n');
	}
	if (typeof message === 'object') {
		const parts = [];
		Object.keys(message).forEach((key) => {
			const value = message[key];
			if (Array.isArray(value)) {
				value.forEach((item) => parts.push(String(item)));
			} else if (typeof value === 'string') {
				parts.push(value);
			}
		});
		if (parts.length > 0) {
			return parts.join('\n');
		}
	}
	return fallback;
}
